/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class RequestAuditEndpointStatisticsResponse {
    getFixupPrototypeFunction() { return RequestAuditEndpointStatisticsResponse.fixupPrototype; }

    static newInstance(model: Partial<RequestAuditEndpointStatisticsResponse>): RequestAuditEndpointStatisticsResponse {
        let obj = Object.assign(new RequestAuditEndpointStatisticsResponse(), model);
        RequestAuditEndpointStatisticsResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<RequestAuditEndpointStatisticsResponse>): RequestAuditEndpointStatisticsResponse {
        if (!model) return null;
        return RequestAuditEndpointStatisticsResponse.newInstance(<RequestAuditEndpointStatisticsResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: RequestAuditEndpointStatisticsResponse) {
        if (!obj) return;

        models.RequestAuditEndpointStatisticsResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: RequestAuditEndpointStatisticsResponse): boolean {
        Object.setPrototypeOf(obj, RequestAuditEndpointStatisticsResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Number of calls for each endpoint or path.
     */
    counts: { [key: string]: number; };

}
